module.exports = __webpack_public_path__ + "static/no-data.16b5a0aa.png";